export interface ImportMetaConfig {
  readonly VITE_PACKAGE_VERSION: string;
  readonly VITE_COMMIT_HASH: string;
  readonly VITE_BUILD_DATE: string;
}

export function makeMetaConfig(config: ImportMetaConfig) {
  return Object.keys(config).reduce(
    (acc, key) => {
      acc[`import.meta.env.${key}`] = JSON.stringify(config[key]);
      return acc;
    },
    {} as Record<string, string>,
  );
}

export const viteConfig: () => ImportMetaConfig = () => ({
  VITE_PACKAGE_VERSION: import.meta.env.VITE_PACKAGE_VERSION,
  VITE_COMMIT_HASH: import.meta.env.VITE_COMMIT_HASH,
  VITE_BUILD_DATE: import.meta.env.VITE_BUILD_DATE,
});
